
export const tabIdEnum = {
  SelectUserTab: 1,
  SelectOrgTab: 2,
  SelectGroupTab: 3,
};